export default __webpack_public_path__ + "static/media/icons8-static-views-100.2f43e656.svg";